import useResourceList from './useResourceList';
import mutationFactory from './mutationFactory';
import useQuery from './useQuery';

import api from '..';

export const useAthletesList = (queryVariables = {}, queryConfig = {}) => {
  const queryResult = useResourceList({ name: 'athletes', api: api.athletes }, queryVariables, queryConfig);

  return {
    athletes: queryResult.resolvedData,
    latestAthletes: queryResult.latestData,
    ...queryResult,
  };
};

export const useAthlete = ({ id }, queryConfig = {}) => {
  const queryResult = useQuery(['athletes', { id }], api.athletes.getById, {
    ...queryConfig,
    enabled: id,
  });

  return {
    athlete: queryResult.data,
    ...queryResult,
  };
};

export const useAthletesByIds = (ids, queryConfig = {}) => {
  const queryResult = useQuery(['athletes', { ids }], api.athletes.getByIds, {
    ...queryConfig,
    enabled: ids?.length > 0,
  });

  return {
    athletes: queryResult.data || [],
    ...queryResult,
  };
};

const createMutation = mutationFactory({ invalidate: 'languages' });

export const useUpdateAthlete = createMutation(api.athletes.update);
